import React, { useState } from 'react';
import { LEAD_CLIENTS } from '../../constants/columns';
import { useTable, usePagination } from 'react-table';
import { useNavigate } from 'react-router-dom';

// components
import ModalForm from '../../components/ModalForm/ModalForm';
import EmptyData from '../../components/EmptyData/EmptyData';
import Alert from '../../components/Alert/Alert';
import Loader from '../../components/Loader/Loader';

// icons
import icon from '../../brand/generated/buttonIcons/leadCreate.svg';
import getLeadCard from '../../api/leads/getLeadCard';
import { useParams } from 'react-router-dom';
import axios from '../../plugins/axios';
import getDealStatuses from '../../api/deals/getDealStatuses';
import getDealPaymentTypes from '../../api/deals/getDealPaymentTypes';
import getDealPaymentStatuses from '../../api/deals/getDealPaymentStatuses';
import alert from '../../helpers/alert';

const formStyles = {
  dealInfo: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a m m' 'b b b b' 'c c c c'` },
  autoForm: { display: 'grid', gap: '20px', gridTemplateColumns: `auto 44px` },
};

const columns = LEAD_CLIENTS;

const LeadClient = () => {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [clients, setClients] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = React.useState({});
  const [succes, setSucces] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const [dealInfo, setDealInfo] = React.useState([
    { type: 'input', value: '', label: 'ÐÐ°ÑÐ°', disabled: true },
    { type: 'input', label: 'ID', value: '', disabled: true },
    { type: 'selectClients', options: [], value: '', style: { gridArea: 'm' }, name: 'clientId' },
    { type: 'selectDealStatuses', value: '', name: 'statusId', options: [] },
    { type: 'selectDealPaymentTypes', value: '', name: 'paymentTypeId', options: [] },
    { type: 'selectDealPaymentStatuses', value: '', name: 'statusPaymentId', options: [] },
    { type: 'input', label: 'Ð¡ÑÐ¼Ð¼Ð° ÑÐ´ÐµÐ»ÐºÐ¸, KZT', value: '', placeholder: 'ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ ÑÐ°ÑÑÐµÑ', disabled: true },
    {
      type: 'input',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ',
      value: '',
      placeholder: 'ÐÐ°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹',
      style: { gridArea: 'c' },
    },
  ]);

  React.useEffect(() => {
    init();
  }, []);

  const init = async () => {
    setLoading(true);
    // api.get(path, params) ÑÐ°Ð¼ Ð·Ð°Ð²Ð¾ÑÐ°ÑÐ¸Ð²Ð°ÐµÑ Ð²ÑÐ¾ÑÐ¾Ð¹ Ð°ÑÐ³ÑÐ¼ÐµÐ½Ñ Ð² { params }, Ð¿Ð¾ÑÑÐ¾Ð¼Ñ
    // { params: { id } } ÑÐµÐ·Ð¶Ð°Ð»Ð¾ ÐºÐ°Ðº params.params.id â id Ð´Ð¾ Ð±ÑÐºÐ° Ð½Ðµ Ð´Ð¾ÑÐ¾Ð´Ð¸Ð»,
    // getLeadCard Ð¾ÑÐ²ÐµÑÐ°Ð» 400, Ð¸ Ð²ÐºÐ»Ð°Ð´ÐºÐ° Ð²ÑÐµÐ³Ð´Ð° Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð° "Ð»Ð¸Ð´ Ð½Ðµ ÐºÐ¾Ð½Ð²ÐµÑÑÐ¸ÑÐ¾Ð²Ð°Ð½".
    await getLeadCard({ id })
      .then((res) => {
        const client = res.data?.client;
        if (!client) return;
        clients[0] = {
          id: client.id,
          name: client.fullName,
          iin: client.iin,
          vip: client.vip,
          company: client.company,
          employe: client.employe,
          phone: client.phone ? '+' + client.phone : '',
          email: client.email,
          broker: 'Ð½ÐµÑ',
          language: client.language,
        };
      })
      .catch((error) => {})
      .finally(() => setLoading(false));
    setClients([...clients]);
  };

  const table = useTable(
    {
      columns,
      data: clients,
    },
    usePagination
  );

  const [autoForm, setAutoForm] = useState({
    title: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ',
    style: formStyles.autoForm,
    name: 'cars',
    form: [],
    value: [],
    add: [{ type: 'selectCars' }, { type: 'delete' }],
  });

  const [equipmentForm, setEquipmentForm] = useState({
    title: 'ÐÐºÑÐµÑÑÑÐ°ÑÑ',
    style: formStyles.autoForm,
    name: 'equipments',
    form: [],
    value: [],
    add: [{ type: 'selectEquipments' }, { type: 'delete' }],
  });

  const [serviceForm, setServiceForm] = useState({
    title: 'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÐµ ÑÑÐ»ÑÐ³Ð¸',
    style: formStyles.autoForm,
    name: 'additionalServices',
    form: [],
    value: [],
    add: [{ type: 'selectServices' }, { type: 'delete' }],
  });

  const [documentForm, setDocumentForm] = useState({
    title: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ',
    style: formStyles.autoForm,
    action: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ ÐµÑÐµ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ',
    form: [],
    add: [{ type: 'select', value: 'Ð«Ð«Ð«Ð«', label: 'Ð£ÑÐ»ÑÐ³Ð°', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' }, { type: 'delete' }],
  });

  const [actions, setActions] = useState([
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ' },
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°ÐºÑÐµÑÑÑÐ°ÑÑ' },
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ ÑÑÐ»ÑÐ³Ñ' },
    // { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ' },
  ]);

  const createDeal = () => {
    setLoading(true);
    let deal = new Object();
    let services = serviceForm.value.length ? serviceForm.value.map((item) => ({ value: item.value })) : [];
    let equipments = equipmentForm.value.length ? equipmentForm.value.map((item) => ({ value: item.value })) : [];
    let cars = autoForm.value.length ? autoForm.value.map((item) => ({ value: item.value })) : [];
    dealInfo.map((item) => {
      if (item.name) deal[item.name] = item.value;
    });

    axios
      .post('/api/crm/deals/createDealFromLead', {
        ...deal,
        services: services,
        equipments: equipments,
        cars: cars,
      })
      .then((res) => {
        setSucces({ message: 'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ° ÑÐ¾Ð·Ð´Ð°Ð½Ð°' });
        setTimeout(() => {
          navigate('/deals');
        }, 1000);
      })
      .catch((error) => alert.error(error.response.data.errorMessage ?? JSON.stringify(error.response)))
      .finally(() => setLoading(false));
  };

  return (
    <>
      {loading && <Loader />}
      <EmptyData
        title={'ÐÐ»Ð¸ÐµÐ½Ñ'}
        subtitle={'Ð­ÑÐ¾ Ð»Ð¸Ð´ ÐµÑÐµ Ð½Ðµ ÐºÐ¾Ð½Ð²ÐµÑÑÐ¸ÑÐ¾Ð²Ð°Ð½ Ð² ÐºÐ»Ð¸ÐµÐ½ÑÐ°...'}
        action="Ð¡Ð¾Ð·Ð´Ð°ÑÑ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ð¸Ð· Ð»Ð¸Ð´Ð°"
        icon={icon}
        func={() => setShowModal(true)}
        table={table}
        data={clients}
      />
      {showModal && (
        <div
          style={{
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'rgba(0, 0, 0, 0.3)',
            display: 'flex',
          }}
        >
          <div style={{ width: '316px' }} />
          <ModalForm
            handleSubmit={createDeal}
            title={'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ° Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼'}
            closeModal={() => setShowModal(false)}
            mainForm={dealInfo}
            handleSetState={setDealInfo}
            handleSetStateAuto={setAutoForm}
            formTitle={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ'}
            grid={formStyles.dealInfo}
            forms={[autoForm, equipmentForm, serviceForm, documentForm]}
            actions={actions}
            setActions={setActions}
            setForm={[setAutoForm, setEquipmentForm, setServiceForm, setDocumentForm]}
            button={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ ÑÐ´ÐµÐ»ÐºÑ'}
            loading={loading}
          />
        </div>
      )}
      {error.message && <Alert message={error.message} onClick={setError} />}
      {succes.message && <Alert message={succes.message} />}
    </>
  );
};

export default LeadClient;
